'use strict';

export default {
  userMenu: {
    logout: 'Se déconnecter',
    notifications: 'Notifications',
  },
};
